import { AfterViewInit, Component, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LangChangeEvent, TranslatePipe, TranslateService } from "@ngx-translate/core";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { SharedModule } from "@shared/shared.module";


@Component({
	template: '<section class="pt-4 px-2 px-lg-0"><h2>{{ "footer.termsConditions" | translate }}</h2><div class="free-text-page pt-3" [innerHTML]="terms"></div></section>',
	imports: [
		SharedModule,
		TranslatePipe
	],
	styleUrl: "./terms-and-conditions.component.scss",
})
export class TermsAndConditionsComponent implements AfterViewInit {
	protected terms = "";
	// market: any;
	wcmService = inject(WcmService);

	translate = inject(TranslateService);
	constructor() {
		this.translate.onLangChange
			.pipe(takeUntilDestroyed())
			.subscribe(
				(event: LangChangeEvent) => {
					this.setData(event.lang);
				}
			);
	}
	private setData(lang: string) {
		this.wcmService.getDocument("terms-conditions", lang)
			.subscribe({
				next: value => {
					this.terms = value;
				},
				error: () => { this.terms = ""; }
			});
	}
	ngAfterViewInit() {
		this.setData(this.translate.getCurrentLang());
	}
}